import { jsxs as c, jsx as a } from "react/jsx-runtime";
import s from "./contact-card-v2.module.less.js";
const b = ({
  title: l,
  name: t,
  geographicAreas: o,
  phone: e,
  phone2: i,
  phone3: r,
  email: n,
  image: d,
  imageLoading: m
}) => /* @__PURE__ */ c("div", { className: s.wrapper, children: [
  d?.url && /* @__PURE__ */ a("img", { src: d.url, alt: d.alt || t, className: s.image, loading: m }),
  /* @__PURE__ */ c("div", { className: s.contentWrapper, children: [
    /* @__PURE__ */ c("div", { className: s.identificationSection, children: [
      /* @__PURE__ */ a("p", { className: [s.name, "body-base bold mb-0"].join(" "), children: t }),
      l && /* @__PURE__ */ a("p", { className: [s.jobTitle, "body-s my-0"].join(" "), children: l }),
      o && /* @__PURE__ */ a("p", { className: [s.geographicAreas, "body-s my-0"].join(" "), children: o })
    ] }),
    /* @__PURE__ */ c("div", { className: s.contactSection, children: [
      n && /* @__PURE__ */ a("a", { href: `mailto:${n}`, className: ["body-s mb-0", s.link].join(" "), children: n }),
      e && /* @__PURE__ */ a("a", { href: `tel:${e}`, className: ["body-s mb-0", s.link].join(" "), children: e }),
      i && /* @__PURE__ */ a("a", { href: `tel:${i}`, className: ["body-s mb-0", s.link].join(" "), children: i }),
      r && /* @__PURE__ */ a("a", { href: `tel:${r}`, className: ["body-s mb-0", s.link].join(" "), children: r })
    ] })
  ] })
] }), h = (l) => /* @__PURE__ */ a("div", { className: "space-my-sm", children: /* @__PURE__ */ a(b, { ...l }) });
export {
  b as ContactCardV2,
  h as ContactCardV2Content,
  b as default
};
